import { V2ApiError } from '../api/v2-errors.js';
import type { IV2Client } from '../api/v2-client.js';

export async function resolveUserIdByEmail(client: IV2Client, email: string): Promise<string> {
  const resp = await client.get<{ members: Array<{ user_id: string; email: string }> }>('/api/v2/members');
  const m = resp.members.find((x) => x.email.toLowerCase() === email.toLowerCase());
  if (!m) throw new V2ApiError(404, 'MEMBER_NOT_FOUND', `No member with email "${email}" in the active grid.`);
  return m.user_id;
}
